import 'SF/form/ModelFieldBinderPlugin.js';
import 'SF/form/ModelCheckboxBinderPlugin.js';
import 'SF/form/NumericRangeField.js';
import 'SF/form/ComboBox.js';
import 'SF/form/GroupComboBox.js';
import 'SF/form/Checkbox.js';
import 'SF/form/ComboBoxListWidthPlugin.js';
import 'SF/form/ComboBoxUnfilteredMinLengthQueryPlugin.js';
import 'SF/form/ComboBoxValueNoLongerExistsPlugin.js';
import 'SF/form/ComboInfoPopup.js';
import 'SF/form/ComparisonField.js';
import 'SF/form/ConnectionComboBox.js';
import 'SF/form/CourseComboBox.js';
import 'SF/form/CourseSectionComboBox.js';
import 'SF/form/CriteriaComboBox.js';
import 'SF/form/DateField.js';
import 'SF/form/DateRangeField.js';
import 'SF/form/DateTimeField.js';
import 'SF/form/EditableCombBox.js';
import 'SF/form/Fieldset.js';
import 'SF/form/HtmlEditor.js';
import 'SF/form/KeyTriggerPlugin.js';
import 'SF/form/LocationCheckboxGroup.js';
import 'SF/form/LocationComboBox.js';
import 'SF/form/LovCombo.js';
import 'SF/form/LovComboFilterPlugin.js';
import 'SF/form/LovGroupingCombo.js';
import 'SF/form/Model.js';
import 'SF/form/ModelComboBoxBinderPlugin.js';
import 'SF/form/ModelDateRangeFieldBinderPlugin.js';
import 'SF/form/ModelHtmlEditorBinderPlugin.js';
import 'SF/form/ModelLovComboBinderPlugin.js';
import 'SF/form/ModelRadioBinderPlugin.js';
import 'SF/form/ModelRadioGroupBinderPlugin.js';
import 'SF/form/MultiSelect.js';
import 'SF/form/PersonComboBox.js';
import 'SF/form/ProgramComboBox.js';
import 'SF/form/QuestionComboBox.js';
import 'SF/form/Radio.js';
import 'SF/form/RadioField.js';
import 'SF/form/SmartComboBoxStandIn.js';
import 'SF/form/StatefulComboBox.js';
import 'SF/form/TermCombo.js';
import 'SF/form/TimeField.js';
import 'SF/form/TrimmedTimeField.js';
import 'SF/form/TimeRangeField.js';
import 'SF/form/Wizard.js';
import 'SF/form/bundle.js';
import 'SF/form/WholeNumberField.js';